import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Countdown extends Component {
  static propTypes = {
    className: PropTypes.string,
    countdownTime: PropTypes.number,
  }

  constructor (props) {
    super(props)

    this.state = {
      number: props.countdownTime,
    }
  }

  componentDidMount () {
    this.timeout = setTimeout(this.updateNumber, 1000)
  }

  componentWillUnmount () {
    clearInterval(this.timeout)
  }

  updateNumber = () => {
    const nextNumber = this.state.number - 1
    this.setState({
      number: nextNumber
    })
    if (nextNumber !== 0) {
      this.timeout = setTimeout(this.updateNumber, 1000)
    }
  }

  render () {
    return <div className={this.props.className}>{this.state.number !== 0 ? this.state.number : null}</div>
  }
}



// WEBPACK FOOTER //
// ./src/components/CameraRecord/Countdown.jsx